export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const EMPTY_QUERY_PARAMS = 'EMPTY_QUERY_PARAMS';
export const RESET_QUERY_PARAMS = 'RESET_QUERY_PARAMS';
/**
 * Action creator to set the current query parameters.
 * @param {Object} params - Key/value pairs of URL parameters.
 * @returns {{type: string, payload: Object}}
 */
export const setQueryParams = params => ({
  type: SET_QUERY_PARAMS,
  payload: params,
});

export const resetQueryParams = () => ({
  type: SET_QUERY_PARAMS,
  payload: undefined,
});

export const emptyQueryParams = () => ({
  type: EMPTY_QUERY_PARAMS,
});

// Function to parse query parameters from the URL and return an object
export const parseQueryParams = location => {
  const searchParams = new URLSearchParams(location.search);
  const params = {};

  // Iterate through URL search params and create an object
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

// Action to dispatch query params to Redux
export const fetchAndDispatchQueryParams = location => dispatch => {
  const params = parseQueryParams(location);

  if (params) {
    resetQueryParams();
  } else {
    dispatch(setQueryParams(params));
  }
};
